<div class="dialog">
  <div class="dialog__header">
    <h2 class="dialog__title">{{ data.title }}</h2>
    <button type="button" class="dialog__close-btn" [attr.aria-label]="'common.close' | translate" (click)="onCancel()">
      <span zagIcon="close"></span>
    </button>
  </div>

  <div class="dialog__body">
    <zag-appearance-editor
      class="dialog__editor"
      [formControl]="appearanceControl"
      [showModeToggle]="false"
      [showImageUrl]="false"
      [showImageUrlInput]="false"
      [defaultIcon]="data.defaultIcon ?? null"
      [iconLabel]="data.iconLabel"
      [colorLabel]="data.colorLabel"
      [imageUrlLabel]="data.imageUrlLabel"
    />
  </div>

  <div class="dialog__footer">
    <button type="button" zagButton="outlined" zagType="secondary" (click)="onCancel()">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="button" zagButton (click)="onSave()">
      {{ 'common.save' | translate }}
    </button>
  </div>
</div>
